import styles from './ChatbotLoader.module.scss';
const loaderLength = [1, 2, 3];
const ChatbotLoader = () => {
  return (
    <span className={styles.typing_indicator}>
      {loaderLength.map(index => {
        return <span key={index} className={styles.typing_circle} />;
      })}
    </span>
  );
};

export default ChatbotLoader;
